import {
  InAppMessage,
  inAppMessageContentKeys,
  isAllowedURIforBraze,
  isInAppMessageActionButtonAction,
  isInAppMessageContentKey,
  isInAppMessageOptionalContentKey,
  isInAppMessageTextStyle,
  isInAppMessageType,
} from '../../../client/braze/types';
import { logger } from '../../../common/logger';

// exported for testing
export const inAppMessageValidator = (message: InAppMessage): boolean => {
  // check that all the keys in InAppMessageContentKeys are in messages.extras
  for (const key of inAppMessageContentKeys) {
    if (!message.extras[key]) {
      logger.error({ message }, `In-app message key "${key}" missing.`);
      return false;
    }
  }

  // check that all the keys in messages.extras are in InAppMessageContentKeys or OptionalKeys
  for (const key in message.extras) {
    if (
      !isInAppMessageContentKey(key) &&
      !isInAppMessageOptionalContentKey(key)
    ) {
      logger.error({ message }, `Unknown In-app message key: ${key}.`);
      return false;
    }
  }

  if (!isInAppMessageType(message.extras.type)) {
    logger.error({ message }, 'In-app message type invalid or missing.');
    return false;
  }

  if (message.extras.imgUrl_fi) {
    // only braze cdn is allowed
    const regex = /^https:\/\/cdn\.braze\.eu\//;
    const isValidUrl_fi = regex.test(message.extras.imgUrl_fi);

    if (!isValidUrl_fi) {
      logger.error({ message }, 'In-app message imgUrl_fi invalid.');
      return false;
    }
  }

  if (message.extras.imgUrl_sv) {
    // only braze cdn is allowed
    const regex = /^https:\/\/cdn\.braze\.eu\//;
    const isValidUrl_sv = regex.test(message.extras.imgUrl_sv);

    if (!isValidUrl_sv) {
      logger.error({ message }, 'In-app message imgUrl_sv invalid.');
      return false;
    }
  }

  if (
    (message.extras.actionButtonLabel_fi &&
      !message.extras.actionButtonLabel_sv) ||
    (!message.extras.actionButtonLabel_fi &&
      message.extras.actionButtonLabel_sv)
  ) {
    logger.error(
      { message },
      'In-app message action button label missing a localized label.'
    );
    return false;
  }

  if (
    message.extras.actionButtonAction &&
    !isInAppMessageActionButtonAction(message.extras.actionButtonAction)
  ) {
    logger.error(
      { message },
      'In-app message action button action invalid or missing.'
    );
    return false;
  }

  if (
    message.extras.actionButtonLabel_fi &&
    !isInAppMessageActionButtonAction(message.extras.actionButtonAction)
  ) {
    logger.error(
      { message },
      'In-app message has actionButton label but invalid actionButtonAction.'
    );
    return false;
  }

  if (
    message.extras.actionButtonAction === 'redirect' &&
    (!message.extras.redirect_uri ||
      !isAllowedURIforBraze(message.extras.redirect_uri))
  ) {
    logger.error(
      { message },
      'In-app message action set for redirect but redirect_uri invalid or missing.'
    );
    return false;
  }

  if (
    message.extras.text_style_fi &&
    !isInAppMessageTextStyle(message.extras.text_style_fi)
  ) {
    logger.error({ message }, 'In-app message text_style_fi invalid.');
    return false;
  }

  if (
    message.extras.text_style_sv &&
    !isInAppMessageTextStyle(message.extras.text_style_sv)
  ) {
    logger.error({ message }, 'In-app message text_style_sv invalid.');
    return false;
  }

  return true;
};
